import { DownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ComponentPropsWithoutRef } from "react";

interface ShrinkingButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  small: boolean;
  arrow?: boolean;
}

export const ShrinkingButton = ({
  small,
  arrow = false,
  ...props
}: ShrinkingButtonProps) => {
  return (
    <Button
    // for some reason, both class and style are needed
    // style gets overwritten when an additional style prop is added to the ShrinkingButton component.
    // class doesn't apply in SegmentedOrDropdown for some reason.
      className={small ? "small-button" : ""}
      style={ small ? {
        padding: "0 5px",
        fontSize: 12,
      } : {}}
      {...props}
    >
      {props.children}
      {arrow && 
        <DownOutlined
          style={small ? {
            marginInlineStart: 4
          } : {}}
        />
      }
    </Button>
  );
};